const colors = {
    primary: '#8186a0',
    secondary: '#8186A0',
    backgroundLight: '#F9F9FC',
    backgroundLightSecondary: '#f8f9fa',
    backgroundDark: '#243845',
    backgroundDarkSecondary: '#162431',
    dark: '#2F2E41',
}

export default colors